<div id="alert-wrapper">
  <div *ngFor="let alert of alerts">
    <ngb-alert [type]="alert.type" (closed)="close(alert)">
      <div class="d-flex align-items-center">
        <i *ngIf="alert.type === AlertType.Primary" class="fas fa-info-circle"></i>
        <i *ngIf="alert.type === AlertType.Warning" class="fas fa-exclamation-triangle"></i>
        <i *ngIf="alert.type === AlertType.Danger" class="fas fa-times-circle"></i>
        <span *ngIf="alert.hasSuffix" [innerHTML]="alert.message + labelService.getLabelSuffix() | translate: alert.translateParams"></span>
        <span *ngIf="!alert.hasSuffix" [innerHTML]="alert.message | translate: alert.translateParams"></span>
      </div>
    </ngb-alert>
  </div>
</div>
